import { Component, EventEmitter, Inject, Input, LOCALE_ID, Output, ChangeDetectionStrategy } from "@angular/core";
import { PollResultService } from "../../../timeline/timeline-item/poll-result/poll-result.service";
import { AgreeDisagreePollResultTask, ClosedPollResultTask, ScalePollResultTask } from "../../taskbook.types";
import { TranslateService } from "@ngx-translate/core";
import { DatePipe } from "@angular/common";
import { PollResultValue } from "app/frontend/lib/timeline/timeline-item/poll-result/poll-result.type";
import { ClosedRecurrencePollResults } from "app/frontend/lib/polls/create-poll/create-poll.type";


@Component({
    selector: 'poll-result-task',
    templateUrl: './poll-result-task.component.html',
    styleUrls: ['./../task.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PollResultTaskComponent {

    protected participationCount: number;
    protected tabIndexToShow: number = 0;
    protected resultsTabLabel: string;
    protected trendsTabLabel: string;

    @Input() task: ClosedPollResultTask | AgreeDisagreePollResultTask | ScalePollResultTask
    @Output() onReported = new EventEmitter()

    constructor(
        private translateService: TranslateService,
        private pollResultService: PollResultService
    ) {
        this.resultsTabLabel = this.translateService.instant('poll_results.results')
        this.trendsTabLabel = this.translateService.instant('poll_results.trends')
    }

    ngOnInit() {
        this.participationCount = this.pollResultService.getParticipationCount(this.task.results.values)
    }

    onTabChanged(event){
        this.tabIndexToShow = event.index;
    }

    reportItem(){
        this.onReported.emit();
    }
}